
import { functions,auth } from "@/scripts/firebase";
import { NoticeProps } from "@/scripts/datatypes"
import {ConfirmationResult,RecaptchaVerifier,sendSignInLinkToEmail, updateEmail,ActionCodeSettings} from 'firebase/auth'
import {httpsCallable} from 'firebase/functions'
import { ValidationObserver } from 'vee-validate'

import { Component,Mixins,Prop } from "vue-property-decorator";
import Common from '@/mixins/common';
import { CheckAuthUserExistsArg , CheckAuthUserExistsRes } from "../common-datatypes"

@Component({
  components: {
    
  }
})

export default class EmailAuth extends Mixins(Common) {
  @Prop({type: Boolean,default: false}) private isShow!: boolean
	@Prop({type: String,default: 'signIn'}) private type!: 'signUp' | 'signIn' | 'reAuth' | 'update'
  @Prop({type: String,default: location.origin }) private continueUrl!: string
  isLoading = false
  email = ''
  recaptchaVerifier?: RecaptchaVerifier
  recaptchaVerified =  false
  recaptchaWidgetId =  0
  verificationCode = ''
  confirmationResult?: ConfirmationResult
  notice = {} as NoticeProps
  
  get observerEmailAuth(){
    return this.$refs.emailAuthValidationObserver as InstanceType<typeof ValidationObserver>;
  }

  get isDisabled(){
    return (this.email && this.recaptchaVerified) ? false : true
  }

  async created(){
    console.trace('created');
  }
 
  async mounted(){
    console.trace('mounted')

    try{
      this.recaptchaVerifier = new RecaptchaVerifier(
        "recaptcha-container",{
          theme: 'light',// UIの色
          size: 'normal',// UIの大きさ
          tabindex: 0, // タブインデックス
          // ユーザーが正常な応答を送信したときに実行される
          callback: () => {
            this.recaptchaVerified = true
            this.observerEmailAuth.setErrors({
              reCAPTCHA: ''
            })
          },
          //reCAPTCHA応答が期限切れになり、ユーザーが再検証する必要があるときに実行される
          //Response expired. Ask user to solve reCAPTCHA again.
          "expired-callback": () => {
            this.observerEmailAuth.setErrors({
              reCAPTCHA: this.$t('authentication.reCAPTCHA.expired') as string
            })
            this.recaptchaVerified = false
          },
          // reCAPTCHAでエラー（通常はネットワーク接続）が発生し、接続が復元されるまで続行できない場合に実行される
          "error-callback": () => {
            this.observerEmailAuth.setErrors({
              reCAPTCHA: this.$t('authentication.reCAPTCHA.error') as string
            })
            this.recaptchaVerified = false
          }
        },auth
      )

      this.recaptchaWidgetId = await this.recaptchaVerifier.render()
    }catch(error){
      //const errorCode = this.$getErrorCode(error)
    }
  }

  destroyed() {
    console.trace('destroyed');
  }

  public async signIn() {
    try{
      this.notice = {
        isShow: false,
      }

      if(! await this.observerEmailAuth.validate() || ! this.recaptchaVerifier || ! this.recaptchaVerified){
        if(! this.recaptchaVerified){
          this.observerEmailAuth.setErrors({
            reCAPTCHA: this.$t('authentication.reCAPTCHA.required') as string
          })
        }
        return false
      }

      this.$store.commit("setLoading",true);
      this.isLoading = true

      const checkAuthUserExists = httpsCallable(functions,'checkAuthUserExists');
      const existsUser = await checkAuthUserExists({identifier: this.email, type: 'email'} as CheckAuthUserExistsArg) as {data: CheckAuthUserExistsRes}

      /**
       * エラーの条件
       * 
       */

      if(existsUser.data && ['signUp','update'].includes(this.type)){
        this.observerEmailAuth.setErrors({
          email: this.$t('emailAuth.alreadyMember') as string
        })
        this.$store.commit("setLoading",false);
        this.isLoading = false
        return
      }else if(! existsUser.data && ['signIn','reAuth'].includes(this.type)){
        this.observerEmailAuth.setErrors({
          email: this.$t('emailAuth.notFound') as string
        })
        this.$store.commit("setLoading",false);
        this.isLoading = false
        return
      }

      const actionCodeSettings: ActionCodeSettings  = {
        url: this.continueUrl,
        handleCodeInApp: true
      }

      //update emailをすでに持っていたかどうかで場合分け
      if(this.type === 'update'){
        if(! auth.currentUser){
          throw new Error
        }

        if(this.$store.state.user.email){
        await updateEmail(auth.currentUser, this.email)
        actionCodeSettings.url = location.origin + '/?action=updateEmail'
        }else{
          actionCodeSettings.url = location.origin + '/?action=linkWithEmail&uid=' + this.$store.state.user.uid
        }
      }
      
      await sendSignInLinkToEmail(auth,this.email, actionCodeSettings)
      window.localStorage.setItem('emailForSignIn', this.email);

      //成功メッセージ表示
      this.$emit("onResult", true)

      this.notice = {
        message: `emailAuth.${this.type}.verification`,
        duration: 0,
        isShow: true,
        type: {'is-success': true}
      }

    }catch(error){
      this.$emit("onResult", false)
      console.table(error)

      const errorCode = this.$getErrorCode(error)
      const errorMessage0 = this.$t('emailAuth.error') as string

      const errorMessage1 = this.$t(this.$getErrorMessageKey(errorCode)) as string

      const errorField = this.$getErrorField(errorCode)

      if(errorMessage1 && errorField){
        this.observerEmailAuth.setErrors({
         [errorField]: errorMessage1
        })
      }

      const errorMessage = (errorMessage1 === '') ? errorMessage0 : errorMessage0 + '<br />' + errorMessage1
      this.notice = {
        message: errorMessage,
        isShow: true,
        type: {'is-danger': true}
			}
    }finally{
      this.$store.commit("setLoading",false);
      this.isLoading = false
    }
  }
}
